// extracted by mini-css-extract-plugin
module.exports = {"container":"OddsUnavailable_container__8xkl8"};